import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MaterialModel } from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-confirmation-material-goods-info',
    templateUrl: './confirmation-material-goods-info.component.html',
    styleUrls: ['./confirmation-material-goods-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationMaterialGoodsInfoComponent implements OnInit {
    public model: MaterialModel;

    public profText: string;
    public stofText: string;
    public dgpText: string;
    public header: string;
    public constructor(
        public readonly modalInstance: BsModalRef,
        private readonly translate: TranslateService,
    ) {}

    public ngOnInit(): void {
        this.header = <string>this.translate.instant('CONFIRMATION_MATERIAL_DANGEROUS_GOODS_TITLE', {
            material: this.model.materialIdentifier.materialNumber.value,
        });
        this.profText = this.model.dangerousGoodsText;
        this.stofText = this.model.hazardousGoodsText;
        this.dgpText = this.model.objInfoDGPText;
    }
}
